document.addEventListener("click", function (event) {
  const discountCard = event.target.closest(".discount-cards--card");
  if (discountCard) {
    handleCardClick(discountCard);
  }
});

function handleCardClick(card) {
  const textToCopy = card.getAttribute("data-coupon-code");
  // Find the nearest notification container in the same section
  const sectionWrapper = card.closest(".discount-cards-content-wrapper");
  const notification = sectionWrapper.querySelector(".discount-cards--notification");

  if (textToCopy) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        notification.textContent = `COUPON CODE copied.`;
        notification.style.opacity = "1";
        setTimeout(() => {
          notification.style.opacity = "0";
        }, 1500);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  }
}
